import { useState} from "react";
import { Route, useHistory } from "react-router";
import { Link } from "react-router-dom";
import RegisterLogo from './images/LogoRegister.png'
//*******************end of UI Materials */
import { useTranslation } from 'react-i18next'; // multi language package
//*******************************iconsax */
import { Barcode, Home2 ,People,CallCalling,Back} from 'iconsax-react';
import { Profile2User } from 'iconsax-react';
import { Profile } from 'iconsax-react';
import Logo from './images/logo-tele.png';
//******************************** */
const ResetPassword = () => {
    //********************************fetching API */


    const history = useHistory();
    const handleSubmit = (e) => {
         e.preventDefault();
         localStorage.setItem('userType' , 1);
         history.push('/regastep2');

    }
    
    const handleSubmit2 = (e) => {
      e.preventDefault();
      localStorage.setItem('userType' , 2);
      history.push('/');

 }
 const handleSubmit3 = (e) => {
  e.preventDefault();
  localStorage.setItem('userType' , 3);
  history.push('/regmstep2');

}
const handleSubmit4 = (e) => {
  e.preventDefault();
  localStorage.setItem('userType' , 4);
  history.push('/register');

}
    //***************************************** */


//***********multi language functios *******/
const {t, i18n} = useTranslation(['Login']);

//***************************************/
    return (
      <><div className="pagePic"></div>
          <div className="loginMainRow form_regisster">
            <div className="rectangle sectionsLogin col-xxl-8 col-xl-9 col-12" id="main-row-2id">
                <div className="mainRegisterheader col-xxl-12 col-12">               
                  <div className="NewHeaderWithHomeIcone col-xxl-12 col-12">
                  <div className="subRegisterrightheader col-md-8 col-12">
                  <Link className="MyHomeNewReg d-md-flex d-none" to='/'>
                        <Home2 color="white" size="32" />
                    </Link>
                    <br/>
                    <h4 className="card-title font-face-gm">{t('Sign Up To Telesiness')+ ' : ' + t('As Distributor')}</h4>
                    <p className="RegisterHeaderp">{t('Dear user, welcome to your registration section')}</p>
                    <p className="RegisterHeaderp">{t('Select the appropriate option to register depending on the following conditions:')}</p>
                    <p className="RegisterHeaderp">{t('1- If you have an invitation code, select the option to register with the code')}</p>
                    <p className="RegisterHeaderp">{t('2- If you intend to cooperate and you think you have the conditions to obtain the code, Contact Us and select the option to Contact Us.')}</p>
                    <p className="RegisterHeaderp">{t('3- If you do not have the conditions to obtain a code, but you want to cooperate, you can start your registration by selecting the Agent option, and after obtaining the necessary points, you can reach the stage of obtaining a code.')}</p>
                    <p className="RegisterHeaderp">{t('4- If none of the conditions are suitable, return to the previous page to display more options.')}</p>
                  </div>
                  <div className="subRegisterleftheader col-md-4 col-12">
                    <img src={RegisterLogo} alt="" />
                    <Link className="font-face-gm backtohome ico_backhome" to='/'>
                        <Home2 color="white" size="24" />
                    </Link>
                  </div>
                  </div>
                </div>
                <div className="progressRow col-xxl-10 col-12">
                  <div className="myshapes">
                    <div className="mycircle">
                      <h6>2 of 5</h6> 
                    </div>
                    <div className="myProCircle"></div>
                  </div>
                  <div className="mytext">
                    <h5 className="step1">{t('Step 2')}</h5>
                    <h6 className="choosText">{t('Choose Your Registration Type')}</h6>
                  </div>
                </div>
                <div className="selectProfile2 col-xxl-10 col-12">
                  {/* <div className="circle">
                    <Link onClick={handleSubmit} className="font-face-gm BriefcaseA" to='/regstep2'>
                      <Briefcase color="white" variant="Bold" size="60" />
                      <span className="css-1iz24ed-MuiChip-root MuiChip-icon">{t('Lawyer')}</span>
                    </Link>
                  </div> */}
                   <div className="CirRect2" onClick={handleSubmit}>
                    <Link onClick={handleSubmit} className="font-face-gm BriefcaseA" to='/regastep2'>
                      <Barcode color="white" variant="Bulk" size="60" />
                      <span className="css-1iz24ed-MuiChip-root MuiChip-icon">{t('Registration with Code')}</span>
                    </Link>
                  </div>
                  <div className="CirRect2">
                    <Link className="font-face-gm BriefcaseA" to="/ContactUsLogin">
                      <CallCalling color="white" variant="Bulk" size="60" />
                      <span className="css-1iz24ed-MuiChip-root MuiChip-icon">{t('Contact Us')}</span>
                    </Link>
                  </div>
                  <div className="CirRect2" onClick={handleSubmit3}>
                  <Link onClick={handleSubmit3} className="font-face-gm BriefcaseA" to='/regmstep2'>
                    <People color="white" variant="Bulk" size="60" />
                    <span className="css-1iz24ed-MuiChip-root MuiChip-icon">{t('Registered as a Agent')}</span>
                    </Link>
                  </div>
                  <div className="CirRect2" onClick={handleSubmit4}>
                  <Link onClick={handleSubmit4} className="font-face-gm BriefcaseA" to='/register'>
                    <Back color="white" variant="Bulk" size="60" />
                    <span className="css-1iz24ed-MuiChip-root MuiChip-icon">{t('Back')}</span>
                    </Link>
                  </div>
                </div>
            </div> 
            <div className="footerDasilav col-12">
              <div className="footer-copy">
                Copyright &copy; 2022 TELESINESS Company, INC.  All Rights Reserved. Privacy Policy
              </div>
              <div className="footer-copy2">
                <br />
                Copyright &copy; 2022 TELESINESS Company, INC.  All Rights Reserved. Privacy Policy
              </div>
            </div>
          </div>
      </>
           
    );
}
 
export default ResetPassword;